import { snapshotConfig } from '../config/configCodec.js'

// ============================================================================
//  saveCta — przycisk „Zapisz" i link „Zapisane boiska (N)" w strefie CTA.
//  Inicjowany RAZ (elementy żyją poza #cfg-panel, więc nie wolno wieszać
//  listenerów przy każdej przebudowie sidebara). Licznik odświeża refresh().
// ============================================================================

export function initSaveCta({ state, savedCourts, onSaved, onOpenSaved }) {
  const btn = document.getElementById('cta-save')
  const link = document.getElementById('cta-saved-link')
  if (!btn || !link) return { refresh: () => {} }

  function refresh() {
    const n = savedCourts.list().length
    link.hidden = n === 0
    link.textContent = `Zapisane boiska (${n})`
  }

  // Feedback na samym przycisku („Zapisano ✓" / błąd) — wraca po 1,5 s.
  let timer = null
  btn.addEventListener('click', () => {
    const entry = savedCourts.save(snapshotConfig(state))
    btn.textContent = entry ? 'Zapisano ✓' : 'Nie udało się zapisać'
    if (entry) onSaved?.()
    refresh()
    clearTimeout(timer)
    timer = setTimeout(() => { btn.textContent = 'Zapisz' }, 1500)
  })
  link.addEventListener('click', () => onOpenSaved?.())

  refresh()
  return { refresh }
}
